import React from 'react';

import './CopyMatchesResults.scss';

class CopyMatchesResults extends React.Component {
  render() {
    const { results } = this.props;
    const length = Object.keys(results).length;
    return (
      <div className="copy-matches-results">
        <div className="copy-matches-results__success icon-reverse icon-circle">
          <i className="icon-check" />
        </div>
        <h3 className="copy-matches-results__title">Matches are Copied!</h3>
        <div className="copy-matches-results__text">
          Matches successfully copied from 1 job(s) to {length} job(s). Click on the job to view matches or{' '}
          <a href="#">download match report</a> for details.
        </div>
      </div>
    );
  }
}

export default CopyMatchesResults;
